import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext';
import { API_BASE_URL, ROUTES } from '../constants';

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const raw = searchParams.get('token');
    if (!raw) {
      setError(t.resetPassword.invalidToken);
    } else {
      setToken(raw);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError(t.resetPassword.passwordMismatch);
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/auth/reset-password`, {
        token,
        new_password: newPassword,
      });
      setSuccess(true);
      setTimeout(() => navigate(`${ROUTES.LOGIN}?reset=1`), 1500);
    } catch (err: any) {
      const detail = err.response?.data?.detail;
      if (detail && typeof detail === 'string') {
        setError(detail);
      } else {
        setError(t.resetPassword.genericError);
      }
    }
  };

  return (
    <div className="reset-password">
      <div className="reset-password__container">
        <div className="reset-password__card">
          <h1 className="login__title italic-title">{t.resetPassword.title}</h1>

          {error && (
            <div className="reset-password__error">
              {error}
              {!token && (
                <Link to={ROUTES.FORGOT_PASSWORD} className="forgot-password__back-link">
                  Request a new link
                </Link>
              )}
            </div>
          )}

          {success && (
            <div className="reset-password__success">{t.resetPassword.successRedirecting}</div>
          )}

          {!success && token && (
            <form className="reset-password__form" onSubmit={handleSubmit}>
              <div className="login__field">
                <label htmlFor="new-password" className="login__label">{t.resetPassword.newPassword}</label>
                <input
                  id="new-password"
                  className="login__input"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  minLength={8}
                />
              </div>
              <div className="login__field">
                <label htmlFor="confirm-password" className="login__label">{t.resetPassword.confirmPassword}</label>
                <input
                  id="confirm-password"
                  className="login__input"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  minLength={8}
                />
              </div>
              <button type="submit" className="login__submit button_primary">
                {t.resetPassword.submit}
              </button>
            </form>
          )}

          {!token && !error && (
            <Link to={ROUTES.FORGOT_PASSWORD} className="forgot-password__back-link">
              Request a new link
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
